<template>
  <el-link ref="export" :type="type" @click="clickExport" :disabled="disabled"><slot></slot></el-link>
</template>

<script>
import Encoding from 'encoding-japanese'

export default {
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      default: 'ダウンロード.txt'
    },
    encoding: {
      type: String,
      default: 'UNICODE'
    },
    contentType: {
      type: String,
      default: 'text/plain'
    },
    fileData: String
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    clickExport () {
      const downloadData = () => {
        if (this.encoding === 'UNICODE') {
          const encoder = new TextEncoder()
          return encoder.encode(this.fileData)
        } else {
          const unicodeList = [...this.fileData].map(x => x.charCodeAt(0))
          const convertArray = Encoding.convert(unicodeList, {
            to: this.encoding,
            from: 'UNICODE'
          })
          return new Uint8Array(convertArray)
        }
      }

      const blob = new Blob([downloadData()], { type: this.contentType })
      const link = this.$refs.export.$el
      link.href = window.URL.createObjectURL(blob)
      link.download = this.fileName
      this.$emit('export')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
</style>
